var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('gmap-map',_vm._b({attrs:{"id":"map","options":_vm.mapControl}},'gmap-map',_vm.options,false),[_c('gmap-marker',{attrs:{"position":_vm.options.center}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }